import type { SurveyPage } from '../../fetchSurvey/types/survey';

export function skipEmptyPagesForward(pages: SurveyPage[], startIndex: number): number {
  let index = startIndex;
  while (index < pages.length && pages[index].questions.length === 0) {
    index += 1;
  }
  return index;
}

export function getNextSequentialPageIndex(pages: SurveyPage[], currentPageIndex: number): number {
  return skipEmptyPagesForward(pages, currentPageIndex + 1);
}

export function isPastLastQuestionPage(pages: SurveyPage[], pageIndex: number): boolean {
  const lastWithQuestions = pages.reduce(
    (last, page, idx) => (page.questions.length > 0 ? idx : last),
    -1
  );
  return pageIndex >= lastWithQuestions;
}
